export default __webpack_public_path__ + "static/media/recruit_section_image_1@2x.5fa8e500.webp";